module.exports = __webpack_public_path__ + "media/4.1e4bee2b.mp4";